import React from 'react';
import {
  LogoImage,
  MainContainer,
  MainLogo,
  MainScreen,
  MainText,
  HeadText,
  MidleLogo,
  Midle,
  HomeLayer,
} from './HomeSectionElements';

import innio from '../../../img/jenbacherinnio.png';
import jenbacher from '../../../img/jenbacher6.png';

import { useLanguage } from '../../../hooks';
import { MainPageText } from '../../Library/LibraryMainPage';

const HomeSection = () => {
  const { lang } = useLanguage();
  return (
    <MainScreen id="home">
      <HomeLayer>
        <MainContainer>
          <MainText>
            <HeadText>{MainPageText[lang].homeHead}</HeadText>
            <Midle>
              <MidleLogo src={innio} />
            </Midle>
            <HeadText>{MainPageText[lang].homeTitle}</HeadText>
          </MainText>

          <MainLogo>
            <LogoImage src={jenbacher} />
          </MainLogo>
        </MainContainer>
      </HomeLayer>
    </MainScreen>
  );
};

export default HomeSection;
